// Helper to get env var from either process.env (Node.js) or import.meta.env (Vite)
const getEnv = (key: string): string | undefined => {
    // Check for Node.js environment
    if (typeof process !== 'undefined' && process.env) {
        return process.env[key];
    }
    // For webpack builds (plugin), environment variables are replaced at build time
    // via DefinePlugin, so we can't use dynamic access to import.meta
    // Instead, we'll return undefined and let the caller use direct property access
    return undefined;
};

// Simple environment detection
export const isWebBuild = () => {
    // Use direct property access for webpack DefinePlugin replacement
    try {
        return import.meta.env.VITE_BUILD_TARGET === 'web';
    } catch {
        return false;
    }
};

export const isPluginBuild = () => {
    // Use direct property access for webpack DefinePlugin replacement
    try {
        return import.meta.env.VITE_BUILD_TARGET === 'plugin';
    } catch {
        return true; // Default to plugin if import.meta not available
    }
};

/**
 * Get the platform source identifier for analytics
 */
export const getPlatformSource = (): 'platform' | 'plugin' => {
  return isWebBuild() ? 'platform' : 'plugin';
};

